/**
 * Public contact — website, phone, social.
 * Phone is omitted from public pages (home, contact, footer); it appears on /resume + PDF only.
 */
export const RESUME_SITE = {
  host: "mohammed-sagban.me",
  url: "https://mohammed-sagban.me",
} as const;

export const PUBLIC_CONTACT = {
  phone: {
    display: "+964 783 131 7146",
    tel: "+9647831317146",
  },
  site: RESUME_SITE,
  github: {
    url: "https://github.com/md-sagban",
    label: "github.com/md-sagban",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/md-sagban/",
    label: "linkedin.com/in/md-sagban",
  },
  x: {
    url: "https://x.com/md_sagban",
    label: "x.com/md_sagban",
  },
  email: "hello@mohammed-sagban.me",
} as const;
